import React from "react";
import ClockLoader from "react-spinners/ClockLoader";

export const TimeLoader = () => {
  return <ClockLoader color="#1c355e" size={50} />;
};
